import axios from "axios";
import { serverAddress } from "../../constant";
import cookie from "js-cookie";

const LawGrievanceAPI = {
  getAll: (params) => {
    let url =
      serverAddress +
      `/law/grievance/get-all?page=${params?.page}&limit=${params?.limit}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },

  findOne: (id) => {
    let url = serverAddress + `/law/grievance/get/${id}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },

  total: () => {
    let url = serverAddress + `/law/grievance/get/total/grievance`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },

  getDocumentUrl: (key) => {
    let url =
      serverAddress + `/law/grievance/document/url?key=${encodeURIComponent(key)}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },
};

export default LawGrievanceAPI;
